var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3366 9.06342L15.6439 6L20.9513 9.06342L19 10.1951L15.6439 8.26342L12.2878 10.1951L10.3366 9.06342ZM20.9513 12.9268L19 11.7951L15.6439 13.7268L12.2878 11.7951L10.3366 12.9268V15.1903L13.6927 17.1219V20.9853L15.6439 22.1171L17.5952 20.9853V17.1219L20.9513 15.1903V12.9268ZM20.9513 19.0537V16.7902L19 17.9219V20.1853L20.9513 19.0537ZM22.3366 19.8537L18.9805 21.7853V24.0487L24.2878 20.9853V14.8585L22.3366 15.9902V19.8537ZM20.3854 10.9951L22.3366 12.1268V14.3903L24.2878 13.2585V10.9951L22.3366 9.86342L20.3854 10.9951ZM13.6927 22.6049V24.8683L15.6439 26L17.5952 24.8683V22.6049L15.6439 23.7366L13.6927 22.6049ZM10.3366 19.0537L12.2878 20.1853V17.9219L10.3366 16.7902V19.0537ZM13.6927 10.9951L15.6439 12.1268L17.5952 10.9951L15.6439 9.86342L13.6927 10.9951ZM8.95122 12.1268L10.9024 10.9951L8.95122 9.86342L7 10.9951V13.2585L8.95122 14.3903V12.1268ZM8.95122 15.9902L7 14.8585V20.9853L12.3073 24.0487V21.7853L8.95122 19.8537V15.9902Z",
    fill: "#F0B90B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/binance.a8bdedaa27f7ff88c6769a0f8b10eeab.svg";
export { ForwardRef as ReactComponent };